module.exports = __webpack_public_path__ + "assets/pdf/E12-cn-working-together.e48f7630.pdf";